<template>
  <div class="card flex-start-center" :class="detail.selected && selectedFlag ? 'card-select' : ''" @click="cardClick">

    <img class="card-img" :src="detail.coverPicture ? detail.coverPicture + parameters : detail.picture + parameters"
      alt="">
    <div class="name-div">
      <p class="name">{{ detail.boxUserId ? detail.boxName : detail.nftName }}</p>
      <!-- <p class="num" v-if="detail.boxUserId">#{{detail.boxUserId}}</p> -->
      <p class="num" v-if="!detail.boxUserId">#{{ detail.nftNo }}</p>
    </div>
  </div>
</template>

<script>
import { ossParameters } from '../../assets/js/globle.js'
export default {
  props: {
    detail: {
      type: Object,
      default: function () {
        return {

        }
      }
    },
    selectedFlag: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },

  data() {
    return {
      parameters: ossParameters(),
      dataArr: []
    }
  },
  mounted() {
    console.log(this.detail)
  },
  methods: {
    cardClick() {
      // boxId
      console.log(this.detail)
      this.$emit('cardClick', this.detail)
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  width: 273px;
  height: 120px;
  background: #FFFFFF;
  border-radius: 3px;
  border: 3px solid #fff;
  cursor: pointer;

  @media screen and(max-width:768px) {
    width: 157px;
    height: 69px;
  }

  .card-img {
    width: 80px;
    height: 80px;
    border-radius: 2px;
    margin: 0 20px;

    @media screen and(max-width:768px) {
      width: 46px;
      height: 46px;
      margin: 0 12px;
    }
  }

  .name-div {
    height: 80px;

    @media screen and(max-width:768px) {
      height: 46px;
    }

    .name {
      font-size: 16px;
      font-weight: 500;
      color: #434343;
      line-height: 22px;
      width: 140px;
      margin: 17px 0 7px 0;
      white-space: nowrap;
      /*强制在一行显示*/
      text-overflow: ellipsis;
      /*设置超出内容显示...*/
      overflow: hidden;

      /*一定不能少 超出的内容进行隐藏*/
      @media screen and(max-width:768px) {
        width: 80px;
        font-size: 13px;
        font-weight: 500;
        color: #434343;
        line-height: 18px;
        margin: 7px 0 0 0;
      }
    }

    .num {
      font-size: 14px;
      font-weight: 400;
      color: #E8721D;
      line-height: 20px;

      @media screen and (max-width:768px) {
        font-size: 10px;
        font-weight: 400;
        color: #E8721D;
        line-height: 14px;
      }

      .total {
        color: #6F6F6F;
      }
    }
  }
}

.card-select {
  border: 3px solid #E26C17;
}
</style>



// WEBPACK FOOTER //
// src/conponents/nftCard/index.vue